export const RolePermissionList = [
   {
      "key": "Home",
      "subkey": [

      ],
      "checked": true,
      "linkName": "/"
   },
   {
      "key": "Microfinance Universe",
      "subkey": [
         {
            "subkey_name": "Overview",
            "subkey_checked": true,
            "sublinkName": ""
         },
         {
            "subkey_name": "Outreach",
            "subkey_checked": true,
            "sublinkName": ""
         },
         {
            "subkey_name": "Disbursement",
            "subkey_checked": true,
            "sublinkName": ""
         },
         {
            "subkey_name": "Portfolio Quality",
            "subkey_checked": true,
            "sublinkName": ""
         }
      ],
      "checked": true,
      "linkName": "/micro-finance-universe"
   },
   {
      "key": "MFIN Members",
      "subkey": [

      ],
      "checked": true,
      "linkName": "/mfinmembersmodule"
   },

   {
      "key":"NBFC-MFI",
      "subkey":[
       {
          "subkey_name":"Overview",
          "subkey_checked":true,
          "sublinkName":""
       },
       {
          "subkey_name":"Portfolio and Outreach",
          "subkey_checked":true,
          "sublinkName":""
       },
       {
          "subkey_name":"Disbursement",
          "subkey_checked":true,
          "sublinkName":""
       },
       {
          "subkey_name":"Portfolio Quality",
          "subkey_checked":true,
          "sublinkName":""
       },
       {
         "subkey_name":"Financials",
         "subkey_checked":true,
         "sublinkName":""
       },
       {
         "subkey_name":"HR (HO & Branch level)",
         "subkey_checked":true,
         "sublinkName":""
       },
       {
         "subkey_name":"Comparison",
         "subkey_checked":true,
         "sublinkName":""
       }
       ],
      "checked":true,
      "linkName":"/micrometer"
   },

   
   {
      "key": "Benchmarks",
      "subkey": [

      ],
      "checked": true,
      "linkName": "/comparison-report"
   },
   {
      "key": "SRO",
      "subkey": [
         {
            "subkey_name": "Credit Bureau",
            "subkey_checked": true,
            "sublinkName": ""
         },
         {
            "subkey_name": "Employee Bureau",
            "subkey_checked": true,
            "sublinkName": ""
         },
         {
            "subkey_name": "QAR",
            "subkey_checked": true,
            "sublinkName": ""
         },
         {
            "subkey_name": "CGRM",
            "subkey_checked": true,
            "sublinkName": ""
         },
         {
            "subkey_name": "RBI Report",
            "subkey_checked": true,
            "sublinkName": ""
         },
         {
            "subkey_name": "Others",
            "subkey_checked": true,
            "sublinkName": ""
         }
      ],
      "checked": true,
      "linkName": "/sro"
   },
   {
      "key": "Mudra",
      "subkey": [
         {
            "subkey_name": "Mudra (Bank Wise)",
            "subkey_checked": true,
            "sublinkName": ""
         }
      ],
      "checked": true,
      "linkName": "/mudra"
   },
   {
      "key": "Custom Report",
      "subkey": [

      ],
      "checked": true,
      "linkName": "/customize-report"
   },
   {
      "key": "Import CSV",
      "subkey": [

      ],
      "checked": true,
      "linkName": "/import-csv"
   },

   {
      "key": "Publication",
      "subkey": [

      ],
      "checked": true,
      "linkName": "/datapublicationcard"
   },
   {
      "key": "DRI",
      "subkey": [

      ],
      "checked": true,
      "linkName": "/dri-states"
   },
   //   {
   //      "key":"Radar",
   //      "subkey":[

   //      ],
   //      "checked":true,
   //      "linkName":"/radar"
   //   },

   {
      "key": "Members and Associate",
      "subkey": [

      ],
      "checked": true,
      "linkName": "/members-associate"
   },
   {
      "key": "Contact Details",
      "subkey": [

      ],
      "checked": true,
      "linkName": "/contacts"
   },
   {
      "key": "Role & Permission",
      "subkey": [

      ],
      "checked": true,
      "linkName": "/role-permission"
   },
   {
      "key": "Admin Account",
      "subkey": [

      ],
      "checked": true,
      "linkName": "/adminUsers"
   },
   {
      "key": "Publication List",
      "subkey": [

      ],
      "checked": true,
      "linkName": "/publicationlist"
   }
]
//export default RolePermissionList;